import { render, staticRenderFns } from "./detail-page.vue?vue&type=template&id=5412bb92&scoped=true&"
import script from "./detail-page.vue?vue&type=script&lang=js&"
export * from "./detail-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412bb92",
  null
  
)

export default component.exports